export const GALLERY_ENTITY_TYPE = {
  Meeting: 1,
  ClubEvent: 2,
  Standalone: 3,
  News: 4,
};

export const GALLERY_ENTITY_TYPE_OPTIONS = [
  { value: GALLERY_ENTITY_TYPE.Standalone, label: 'Bağımsız Galeri' },
  { value: GALLERY_ENTITY_TYPE.Meeting, label: 'Haftalık Toplantı' },
  { value: GALLERY_ENTITY_TYPE.ClubEvent, label: 'Etkinlik' },
  { value: GALLERY_ENTITY_TYPE.News, label: 'Haber' },
];

export const galleryEntityTypeLabel = (type) =>
  GALLERY_ENTITY_TYPE_OPTIONS.find((x) => x.value === Number(type))?.label || '-';

export const MAX_GALLERY_IMAGES = 50;

export const initialEntityGalleryForm = {
  enabled: false,
  title: '',
  description: '',
  showOnDetailPage: true,
  showInGalleryPool: true,
  files: [],
  previews: [],
};

export const buildCreateEntityGalleryDto = (galleryForm) => {
  if (!galleryForm?.enabled) return undefined;
  return {
    title: galleryForm.title?.trim() || null,
    description: galleryForm.description?.trim() || null,
    showOnDetailPage: Boolean(galleryForm.showOnDetailPage),
    showInGalleryPool: Boolean(galleryForm.showInGalleryPool),
  };
};
